import React from "react";

import Block from "./Block";

const PatternGrid = ({
  cols,
  rows,
  updatePattern,
  pattern,
  color,
  defaultColor,
  rotation = 0,
}) => {
  const generateRows = () => {
    const beadRows = [];

    let gridTotalNumberBeads = cols * rows;
    let counter = gridTotalNumberBeads + 1;

    for (let i = 0; i < rows; i++) {
      const gridItems = [];

      for (let j = 0; j < cols; j++) {
        counter--;
        gridItems.unshift(
          <Block
            defaultColor={defaultColor}
            paletteColor={color}
            pattern={pattern}
            updatePattern={updatePattern}
            row={rows - i}
            col={j + 1}
            key={j}
            beadsPerRow={cols}
            beadNumber={counter}
          ></Block>
        );
      }

      beadRows.push(<tr key={i}>{gridItems}</tr>);
    }

    return beadRows;
  };

  return (
    <div
      className="pattern pattern-grid"
      style={{
        transform: `rotate(${rotation}deg)`,
        transformOrigin: "center",
      }}
    >
      <table>
        <tbody>{generateRows()}</tbody>
      </table>
    </div>
  );
};

export default PatternGrid;
